const trackViewItem = (product) => {
  if (typeof window === "undefined" || !product?.id) {
    return;
  }

  const productData = {
    currency: product.currency,
    value: Number(product.featured_price),
    items: [
      {
        item_id: String(product.id),
        item_name: product.title,
        price: Number(product.featured_price),
        quantity: 1,
      },
    ],
  }

  window.dataLayer = window.dataLayer || [];

  window.dataLayer.push({ ecommerce: null });

  window.dataLayer.push({
    event: "app_analytics",    
    analytics_event_name: "view_item",
    ecommerce: productData
  });
};


const trackBeginCheckout = (reservation) => {
  if (typeof window === "undefined" || !reservation?.id) {
    return;
  }

  const cartItems = reservation.items.map((item) => {
    return ({
      item_id: String(item.external_reservation_id),
      item_name: item.product.title,
      price: Number(item.total_price),
      quantity: 1
    })
  })

  const checkoutData = {
    currency: reservation.currency,
    value: Number(reservation.final_price),
    items: cartItems,
  }

  window.dataLayer = window.dataLayer || [];

  window.dataLayer.push({ ecommerce: null });

  window.dataLayer.push({
    event: "app_analytics",
    analytics_event_name: "begin_checkout",
    ecommerce: checkoutData,
  });
};

const trackPurchase = (reservation) => {
  if (typeof window === "undefined" || !reservation?.id) {
    return
  }

  if (reservation.status != 'confirmed') {
    return
  }

  const cartItems = reservation.items.map((item) => {
    return ({
      item_id: String(item.external_reservation_id),
      item_name: item.product.title,
      price: Number(item.total_price),
      quantity: 1
    })
  })

  const checkoutData = {
    transaction_id: reservation.uuid,
    currency: reservation.currency,
    value: Number(reservation.final_price),
    items: cartItems,
  }

  window.dataLayer = window.dataLayer || [];

  window.dataLayer.push({ ecommerce: null });

  window.dataLayer.push({
    event: "app_analytics",
    analytics_event_name: "purchase",
    ecommerce: checkoutData,
  });
};

export {trackViewItem, trackBeginCheckout, trackPurchase}